import React, { FC, useRef, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useAuth } from '../../../hooks/auth/use_auth'
import { useNavigate } from 'react-router-dom'
import { useSnackBar } from '../../../providers/snack_bar_provider'
import { useLoading } from '../../../providers/loading_provider'
import { getKyousouApiClient } from '../../../services/network'
type Props = {
  children: React.ReactNode
}

const DashboardLink: FC<Props> = (props) => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const { showSnackBar } = useSnackBar()
  const { showLoading, hideLoading } = useLoading()

  const [formToken, setFormToken] = useState('')
  const [formKey, setFormKey] = useState('')
  const [formUserId, setFormUserId] = useState('')

  const formRef = useRef<HTMLFormElement>(null)

  const apiClient = getKyousouApiClient()

  const transferDashboard = async () => {
    if (!user) {
      showSnackBar(['ログインしてください'], 'error')
      navigate('login')
      return
    }

    showLoading()

    try {
      // キーの設定
      const key = uuidv4()
      setFormKey(key)

      // トークンの設定
      const response = await apiClient.auth.tokenDashboardCreate({
        key: key,
      })

      setFormToken(response.data.token)
      setFormUserId(response.data.userId)

      // フォームの送信
      setTimeout(() => {
        hideLoading()
        formRef.current?.submit()
      }, 100)
    } catch (e) {
      hideLoading()
      console.error(e)
      showSnackBar(
        [
          'エラーが発生しました。お手数ですがお問い合わせよりお問い合わせください。',
        ],
        'error'
      )
    }
  }

  return (
    <>
      <div onClick={transferDashboard}>
        {props.children}
        <form
          ref={formRef}
          action={`${process.env.REACT_APP_DASHBOARD_URL}/auth/token/dashboard/check`}
          className="hidden"
          method="post"
        >
          <input type="hidden" name="token" value={formToken} />
          <input type="hidden" name="key" value={formKey} />
          <input type="hidden" name="user_id" value={formUserId} />
        </form>
      </div>
    </>
  )
}

export default DashboardLink
